import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';
import {CommonService} from '../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {LoadingService} from '../services/loading.service';
import {MatCheckboxChange, MatDialog, MatStepper, MatTableDataSource} from '@angular/material';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {SelectionModel} from '@angular/cdk/collections';

interface Kind {
  id: number;
  name: string;
}

@Component({
  templateUrl: './maintenance-form.component.html'
})
export class MaintenanceFormComponent implements OnInit {
  public groupsDataSource: MatTableDataSource<Maintenance>;
  public groupsDisplayColumns: string[] = ['select', 'id', 'name'];
  public refrigeratorsDataSource: MatTableDataSource<Refrigerator>;
  public refrigeratorDisplayColumns: string[] = ['select', 'serial_number', 'material_id', 'material_name', 'batch_name', 'model_name', 'sale_point_customer_name'];
  public selection: SelectionModel<any>;
  public selectionRefrigerator: SelectionModel<any>;
  public isLoading: boolean;
  public tableContainerHeight: any;
  public tableContainerWidth: any;
  public cardContainerHeight: any;
  public cardContainerWidth: any;
  public tableHeight: any;
  private selectedGroup: any;
  public selectedKind: Kind;
  public kinds: Kind[] = [];
  itemsLoading = false;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('paginatorRefrigerator', {static: true}) paginatorRefrigerator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('stepper', {static: false}) stepper: MatStepper;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog) {
    this.groupsDataSource = new MatTableDataSource<Maintenance>();
    this.refrigeratorsDataSource = new MatTableDataSource<Refrigerator>();
    this.selection = new SelectionModel<any>(true, []);
    this.selectionRefrigerator = new SelectionModel<any>(true, []);
    this.cardContainerHeight = window.innerHeight - 200;
    this.cardContainerWidth = window.innerWidth - 310;
    this.tableContainerHeight = window.innerHeight - 350;
    this.tableContainerWidth = window.innerWidth - 310;
    this.tableHeight = this.tableContainerHeight - 150;
    this.initKinds();
  }


  async initKinds() {
    try {
      this.kinds = await this.commonService.getSimpleList(`repair_kind`) as Kind[];
    } catch (e) {
    }
  }

  public async ngOnInit(): Promise<any> {
    await this.initGroups();
  }

  private async initGroups() {
    // this.loadingService.show();
    try {
      this.groupsDataSource.data = await this.commonService.getSimpleList(`sales_group`) as Maintenance[];
      this.initPaginatorAndSort();
    } catch (e) {
    } finally {
      this.loadingService.hide();
    }
  }


  previous() {
    this.stepper.previous();
  }

  async next() {
    if (this.stepper.selectedIndex === 0) {
      this.selectedGroup = this.selection.selected[0];
      try {
        this.itemsLoading = true;
        this.refrigeratorsDataSource.data = await this.commonService.getSimpleList(`refrigerator/refrigerator2?filter=sales_group_id=${this.selectedGroup.id} AND phase_id=5`) as Refrigerator[];
        this.refrigeratorsDataSource.paginator = this.paginatorRefrigerator;
        this.stepper.next();
      } catch (e) {
      } finally {
        this.itemsLoading = false;
      }
    }
  }


  isFirstStepInvalid() {
    return this.selection.selected.length === 0;
  }

  isSecondStepInvalid(): boolean {
    return this.selectionRefrigerator.selected.length === 0 || !this.selectedKind;
  }


  async submit() {
    const refrigeratorList = [];
    this.selectionRefrigerator.selected.forEach(refrigerator => {
      refrigeratorList.push({
        sale_point_id: refrigerator.sale_point_id,
        serial_number: refrigerator.serial_number,
        damages: [],
        special_damages: [],
        files: []
      });
    });

    const model = {
      sale_point_id: null,
      details: refrigeratorList,
      type_id: 1,
      kind_id: this.selectedKind.id
    };

    try {
      this.itemsLoading = true;
      await this.commonService.insertObject('repair/web', model);
      this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις εντολές συντήρησης',
          redirectURL: `maintenance`
        }
      });
    } catch (e) {
    } finally {
      this.itemsLoading = false;
    }
  }

  //#region paginator - sorters - filters
  private initPaginatorAndSort() {
    this.groupsDataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
    this.groupsDataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    this.groupsDataSource.filter = filterValue.trim().toLowerCase();
  }

  applyRefrigeratorFilter(filterValue: string) {
    this.refrigeratorsDataSource.filter = filterValue.trim().toLowerCase();
  }

  selectRow(row: any) {
    this.selection.clear();
  }

  selectionChanged($event: MatCheckboxChange, row: any) {
    if ($event.checked === false) {
      return this.selection.deselect(row);
    } else {
      return this.selection.select(row);
    }
  }

  selectRefrigeratorRow(row: any) {
    // /this.selectionRefrigerator.clear();
  }

  selectionRefrigeratorChanged($event: MatCheckboxChange, row: any) {
    if ($event.checked === false) {
      return this.selectionRefrigerator.deselect(row);
    } else {
      return this.selectionRefrigerator.select(row);
    }
  }

  selectRow1(row: any) {
    const oldSelected = this.selection.selected;
    if (oldSelected.length > 0) {
      this.selection.clear();
      this.selection.toggle(row);
    }
    if (oldSelected[0] === row || oldSelected.length === 0) {
      this.selection.toggle(row);
    }
  }

  //#endregion
}

interface Maintenance {
  id: string;
  name: string;
  distribution_center_id: number;
}

interface Refrigerator {
  id: number;
  serial_number: string;
  material_id: string;
  material_name: string;
  batch_id: number;
  batch_name: string;
  eikastiko_id: string;
  eikastiko_name: string;
  weight_net: number;
  model_id: string;
  model_name: string;
  quality_id: string;
  quality_name: string;
  manufacturer_id: string;
  manufacturer_name: string;
  equipment_id: string;
  sale_point_id: number;
  sale_point_customer_name: string;
  sale_point_customer_code: string;
  sales_group_id: string;
  sales_group_description: string;
  is_new: number;
  phase_id: number;
  is_active: number;
  can_be_loaded: number;
  can_be_received: number;
  can_be_returned: number;
  can_be_unloaded: number;
}
